import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityDetailedContent,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import Stack from '@/design_system/Stack';
import IconArchive from '@/icons/Archive.svg';

export const RequestManuallyArchivedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'request_manually_archived'>;
}) => {
  const creatorName = activity.creator.name ?? '';

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="danger"
      icon={<IconArchive />}
      message={
        <BaseActivityText>
          <Trans id="activities.request_manually_archived.message">
            <strong>{creatorName}</strong> archived the request
          </Trans>
        </BaseActivityText>
      }
    >
      {!!activity.data.reason && (
        <Stack style={{ flex: 1, paddingTop: '0.25rem' }}>
          <BaseActivityDetailedContent>{activity.data.reason}</BaseActivityDetailedContent>
        </Stack>
      )}
    </BaseActivity>
  );
};
